const PRODUCT_STAR_WIDGET = 'etrusted-product-star-widget'

let disconnectGuardPromise

export function installTrustedShopsDisconnectGuard() {
  if (!window.customElements || disconnectGuardPromise) {
    return disconnectGuardPromise
  }

  disconnectGuardPromise = window.customElements
    .whenDefined(PRODUCT_STAR_WIDGET)
    .then(() => {
      const elementClass = window.customElements.get(PRODUCT_STAR_WIDGET)
      const prototype = elementClass?.prototype
      const disconnectedCallback = prototype?.disconnectedCallback

      if (typeof disconnectedCallback !== 'function' || disconnectedCallback.__polyestershoppenGuarded) {
        return
      }

      // eTrusted v2 can remove a product-star element while its async initialization is still running.
      // Its cleanup assumes `context` already exists and otherwise throws while InstantSearch replaces hits.
      if (!Function.prototype.toString.call(disconnectedCallback).includes('handleOSStyleListener')) {
        return
      }

      const guardedDisconnectedCallback = function (...args) {
        if (!this.context) {
          return
        }

        return disconnectedCallback.apply(this, args)
      }

      Object.defineProperty(guardedDisconnectedCallback, '__polyestershoppenGuarded', { value: true })
      prototype.disconnectedCallback = guardedDisconnectedCallback
    })
    .catch((error) => {
      console.warn('Trusted Shops disconnect guard could not be installed.', error)
    })

  return disconnectGuardPromise
}
